import PropTypes from 'prop-types';

export default {
  id: PropTypes.number,
  title: PropTypes.string,
  parentId: PropTypes.number,
  beginDate: PropTypes.string,
  expirationDate: PropTypes.string,
  deleted: PropTypes.number
};
